
// Basics

window.id = function _id (n) {
  return n;
};

window.log = function _log () {
  console.log.apply(console, arguments);
  return arguments[0];
};

window.err = function _err () {
  console.error.apply(console, arguments);
  return arguments[0];
};

window.isdef = function isdef (thing) {
  return typeof thing !== 'undefined';
}

window.isLocal = function () {
  return window.location.toString().indexOf('.local') > -1;
}


// Dom

window.findInside = function findInside (el) {
  return function (sel) {
    return $(sel, el);
  };
};

window.QSA = function QSA (selector, el) {
  el = el || document;
  var x = el.querySelectorAll(selector);
  return Array.prototype.slice.apply(x);
}


// Objects

window.cloneMerge = function cloneMerge (original, imported) {
  return Object.assign( Object.assign({}, original), imported );
};

window.zip = function zip (as, bs) {
  var obj = {};
  for (var i in as) obj[as[i]] = bs[i];
  return obj;
}

window.dot = function dot (prop) {
  return function (thing) {
    return thing[prop];
  };
};


// Detect drag n drop support as a browser feature

window.detectDragSupport = function detectDragSupport () {
  var div = document.createElement('div');
  return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
};


// Formatting

window.lowercase = function lowercase (word) {
  return word.toLowerCase();
}

window.capitalise = function capitalise (word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

window.padTwo = function padTwo (n) {
  return (n < 10) ?  '0' + n : n.toString();
}

window.formatDateHumanShort = function formatDateHumanShort (dateString) {
  var months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ];
  var date = new Date(dateString);
  return date.getDate() + " " + months[ date.getMonth() - 1 ] + " " + date.getFullYear();
}

window.formatTimestampHumanShort = function formatDateHumanShort (dateString) {
  var date = new Date(dateString);
  return date.getDate() + "-" + date.getMonth + "-" + date.getFullYear();
}

window.formatMoney = function formatMoney (n) {
  var isInt = (parseFloat(n, 10) - parseInt(n, 10) !== 0);
  return '$' + parseFloat(n, 10).toFixed(isInt ? 2 : 0);
}

window.truncateChars = function truncateChars (n, text) {
  if (text && text.length >= n) return text.substr(0, n) + '…';
  return text;
}

window.fillTemplate = function fillTemplate (template, data) {
  return template.split(/{{(\w+)}}/).map(function (fragment) {
    return (typeof data[fragment] !== 'undefined') ? data[fragment] : fragment;
  }).join("");
}

window.pluralise = function pluralise (word, count) {
  var z = count === 1;

  switch (word) {
    case 'is':   case 'are':     return z ? 'is'    : 'are';
    case 'do':   case 'does':    return z ? 'does'  : 'do';
    case 'was':  case 'were':    return z ? 'was'   : 'were';
    case 'has':  case 'have':    return z ? 'has'   : 'have';
    case "it's": case "they're": return z ? "it's"  : "they're";
    case "this": case "these":   return z ? "this"  : "these";
    case 'it':   case 'them':    return z ? 'it'    : 'them';
    case 'they':                 return z ? 'it'    : 'they';
    default: return z ? word : word + 's';
  }
}

window.pluraliseBody = function pluraliseBody (body, count) {
  var chunk, chunks = body.split(/\{|}/);

  for (i = 0; i < chunks.length; i++) {
    chunk = chunks[i];

    if (chunk.trim() === '') {
      // Skip if chunk is meaningless whitespace
    } else if (chunk === 'n') {
      chunks[i] = count;
    } else if (chunk.indexOf(' ') === -1) {
      var c = chunk[0], isCap = lowercase(c) !== c;
      var result = pluralise(lowercase(chunk), count);
      chunks[i] = isCap ? capitalise(result) : result;
    }
  }

  return chunks.join('');
}


// Lists

window.contains = function contains (list, needle) {
  return -1 < list.indexOf(needle);
}

window.remove = function remove (list, needle) {
  return list.filter(function (x) { return x !== needle; });
}

window.any = function any (list) {
  return list.reduce(function (a, b) { return a || b; }, false)
}

window.all = function all (list) {
  return list.reduce(function (a, b) { return a && b; }, true)
}


// Functional Composition

window.compose = function compose (f, g) {
  return function () {
    g(f.apply(null, arguments));
  };
};

window.jqe = function jqe (λ) {
  return function _jqe (event) {
    λ.call(null, this, event);
  };
}


// Events

window.whichKey = function whichKey (code, λ) {
  return function _whichKey (event) {
    if (event.which === code) {
      λ(event);
    }
  };
};

window.whichKeyMod = function whichKey (code, mod, λ) {
  return function _whichKey (event) {
    if (event.which === code && event[mod]) {
      λ();
    }
  };
};

window.swallow = function swallow (λ) {
  return function _swallow (event) {
    event.preventDefault();
    λ.apply(this, arguments);
  };
}


// Maths

window.limit = function limit (min, max, n) {
  if (arguments.length === 2) {
    return function _limit_curry (n) {
      return n < min ? min : n > max ? max : n;
    };
  } else {
    return n < min ? min : n > max ? max : n;
  }
}

window.wrap = function wrap (min, max, n) {
  if (arguments.length === 2) {
    return function _wrap_curry (n) {
      return n < min ? max : n > max ? min : n;
    };
  } else {
    return n < min ? max : n > max ? min : n;
  }
}


// Timers

window.delay = function delay (t, λ) {
  var n = setTimeout(λ, t * 1000);
  return { cancel: function () { clearTimeout(n); } };
};

window.defer = function defer (λ) {
  return setTimeout(λ, 0);
};

window.reloadPage = function reloadPage () {
  window.location = window.location;
};


// Fetch Json in regulated manner

window.fetchJson = function fetchJson (url, success, error, logging) {

  function receive (response) {
    if (logging) log('fetchJson::receive -', response);
    if (response.is_error) {
      error(response.reason);
    } else {
      success(response.value);
    }
  }

  function done () {
    if (logging) log('fetchJson::done -\n', xhr.response);
    try {
      var response = JSON.parse(xhr.response);
    } catch (e) {
      if (logging) log('fetchJson::done - JSON parse failed', xhr.response);
      console.error('fetchJson - JSON parse failed', xhr.response);
      console.trace();
      var response = { is_error: true, reason: "JSON Parse error: " + e, response: xhr.response };
    }
    receive(response);
  }

  function onerror (err) {
    if (xhr.status !== 200) {
      receive('{ "is_error": true, "reason": "HTTP error: ' + xhr.status + '" }');
    } else {
      receive('{ "is_error": true, "reason": "JS error: ' + err + '" }');
    }
  }

  // Dispatch
  var xhr = new XMLHttpRequest();
  xhr.onload = done;
  xhr.onerror = onerror;
  xhr.open("GET", url);
  xhr.send();

  if (logging) log('fetchJson::init -', url);

};

window.safeJsonParse = function safeJsonParse (text) {
  try {
    return JSON.parse(text);
  } catch (e) {
    console.warn('FilterTable::parse - json parse failed:', e);
    console.log(text);
    return [];
  }
}


// Console monkeypatches

console.green  = function (msg) { console.log('%c' + msg, 'color: #00bb33'); }
console.orange = function (msg) { console.log('%c' + msg, 'color: #FF4C33'); }


//
// Reference Constants
//

window.KEY_TILDE = 192;
window.KEY_GRAVE = 96;
window.MOD_CTRL  = 'ctrlKey';
window.MOD_SHIFT = 'shiftKey';

window.ON = true;
window.OFF = false;

